import {actions} from "./actions";

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload
      };
    default:
      return state;
  }
};